import React, { SyntheticEvent, useEffect, useState } from 'react';
import { Button, Header, Icon, Message, Modal, ModalActions, ModalContent } from 'semantic-ui-react';
import CustomMap from '../../../components/CustomMap';
import { toast } from 'react-toastify';

interface AddressMapModalProps {
    currentLatitude: number | undefined;
    currentLongitude: number | undefined;
}

const AddressMapModal = ({ currentLatitude, currentLongitude }: AddressMapModalProps) => {

    const [openModal, setOpenModal] = useState(false);
    const [latitude, setLatitude] = useState<number | undefined>(currentLatitude);
    const [longitude, setLongitude] = useState<number | undefined>(currentLongitude);

    useEffect(() => {
        setLatitude(currentLatitude);
        setLongitude(currentLongitude);
    }, [currentLatitude, currentLongitude]);

    const handleOpen = (event: SyntheticEvent) => {
        event.preventDefault();
        setOpenModal(true);
    };

    const handleCancel = (event: SyntheticEvent) => {
        event.preventDefault();
        setOpenModal(false);
    };

    const handleShareLocation = () => {
        // copy to clipboard
        const mapsLink = 'https://maps.google.com/maps?q=';
        navigator.clipboard.writeText(`${mapsLink}${latitude},${longitude}`);
        toast.success("Ubicación copiada al portapapeles");
    };

    return (
        <Modal
            closeOnDimmerClick
            closeIcon={true}
            size="small"
            onClose={(event) => handleCancel(event)}
            open={openModal}
            trigger={
                <Button color="green" icon size="mini" onClick={(event) => handleOpen(event)}>
                    <Icon name="marker" /> Ubicación de la instalación
                </Button>
            } >
            <Header icon="map marker alternate" content="Ubicación de la instalación" />
            <ModalContent>

                <Message
                    icon="share"
                    header="Compartir ubicación"
                    content="Usa el botón de abajo para copiar y compartir la ubicación de la instalación"
                />

                <CustomMap
                    height="400px"
                    width="100%"
                    initialLatitude={latitude}
                    initialLongitude={longitude}
                    draggable={false}
                    onLocationChange={(latitude, longitude) => {
                        setLatitude(latitude);
                        setLongitude(longitude);
                    }}
                />

            </ModalContent>
            <ModalActions>
                <Button onClick={(event) => handleCancel(event)}>
                    <Icon name="cancel" /> Cancelar
                </Button>
                <Button color="green" onClick={handleShareLocation}>
                    <Icon name="copy" /> Copiar ubicación
                </Button>
            </ModalActions>
        </Modal>
    );
};

export default AddressMapModal;
